import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Utensils, Dumbbell, Wind } from 'lucide-react';
export function ProtocolSection() {
  return <section className="w-full px-6 py-20 md:py-28 bg-white/50 border-y border-cream-200" data-id="element-123">
      <div className="max-w-3xl mx-auto" data-id="element-124">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-125">
          <h2 className="font-serif text-3xl md:text-4xl text-stone-800 mb-4" data-id="element-126">
            What you will do for 21 days
          </h2>
          <p className="text-lg text-stone-600" data-id="element-127">
            Minimum effective actions that create momentum without burnout.
          </p>
        </motion.div>

        <div className="space-y-12" data-id="element-128">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="flex gap-6 md:gap-10 items-start" data-id="element-129">
            <div className="flex-shrink-0 mt-1" data-id="element-130">
              <Moon className="w-8 h-8 text-terracotta" data-id="element-131" />
            </div>
            <div data-id="element-132">
              <h3 className="font-serif text-2xl text-stone-800 mb-2" data-id="element-133">
                Sleep Lock
              </h3>
              <p className="text-stone-600 text-lg" data-id="element-134">
                Morning light, caffeine cutoff, one wind down action.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="flex gap-6 md:gap-10 items-start" data-id="element-135">
            <div className="flex-shrink-0 mt-1" data-id="element-136">
              <Utensils className="w-8 h-8 text-terracotta" data-id="element-137" />
            </div>
            <div data-id="element-138">
              <h3 className="font-serif text-2xl text-stone-800 mb-2" data-id="element-139">
                Protein Lock
              </h3>
              <p className="text-stone-600 text-lg" data-id="element-140">
                Anchor meals that reduce cravings and decision fatigue.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="flex gap-6 md:gap-10 items-start" data-id="element-141">
            <div className="flex-shrink-0 mt-1" data-id="element-142">
              <Dumbbell className="w-8 h-8 text-terracotta" data-id="element-143" />
            </div>
            <div data-id="element-144">
              <h3 className="font-serif text-2xl text-stone-800 mb-2" data-id="element-145">
                Lift Lock
              </h3>
              <p className="text-stone-600 text-lg" data-id="element-146">
                Three simple strength sessions per week, with a fatigue system
                for hard weeks.
              </p>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="flex gap-6 md:gap-10 items-start" data-id="element-147">
            <div className="flex-shrink-0 mt-1" data-id="element-148">
              <Wind className="w-8 h-8 text-terracotta" data-id="element-149" />
            </div>
            <div data-id="element-150">
              <h3 className="font-serif text-2xl text-stone-800 mb-2" data-id="element-151">
                Bloat Lock
              </h3>
              <p className="text-stone-600 text-lg" data-id="element-152">
                A trigger rotation that stops the daily panic.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}